import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 180px;
`;

export const CopyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  flex: 1;

  h3 {
    max-width: 370px;
  }
`;

export const IllustrationWrapper = styled.div`
  flex: 0 1 325px;
  position: relative;
  background-image: url('https://buffer-publish.s3.amazonaws.com/images/connect-youtube-banner.svg');
  background-size: cover;
`;
